import { styled } from "@mui/material/styles";
import { Box, Card } from "@mui/material";

export const StyledContainer = styled(Box)(({ theme }) => ({
  maxWidth: "900px",
  margin: "40px auto",
  padding: "20px",
  backgroundColor: "#fafafa",
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: theme.shadows[2],
  marginTop: "120px",
}));

export const StyledCard = styled(Card)(({ theme }) => ({
  marginTop: theme.spacing(4),
  boxShadow: theme.shadows[3],
}));

export const StyledExpiredCard = styled(Card)(({ theme }) => ({
  marginTop: theme.spacing(4),
  backgroundColor: "#ffe6e6",
}));

export const LoadingContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  marginTop: theme.spacing(6),
}));

export const LockerDetailsGrid = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(4),
}));

export const HistorySection = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
}));

export const ActionButton = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(2),
}));

export const StatusIcon = styled(Box, {
  shouldForwardProp: (prop) => prop !== "status",
})(({ theme, status }) => ({
  color: status === "locked" ? theme.palette.error.main : theme.palette.success.main,
  display: "flex",
  alignItems: "center",
}));

export const AnimationModal = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 200,
  height: 200,
  backgroundColor: theme.palette.background.paper,
  border: "2px solid #000",
  boxShadow: theme.shadows[24],
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(2),
}));